<template>
  <div>
  <div id="wselect">
    <el-select filterable v-model="deveuis" @change="checkHistory" placeholder="请选择">
          <el-option
             
            v-for="item in workOptions"
            :key="item.deviceNo"
            :label="item.personName"
            :value="item.deviceNo">
          </el-option>
        </el-select>
    </div>
    
    <div class="block">
    
      <el-date-picker
        @change="dateChange"
        v-model="SETime"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        >
      </el-date-picker>
    </div>
    <div id="historyContainer">
      
    </div>
  </div>
</template>

<script>
import {
  Viewer,
  Ion,
  JulianDate,
  TimeIntervalCollection,
  VelocityOrientationProperty,
  Cartesian3,
  ClockRange,
  CzmlDataSource,
  SampledPositionProperty,
  TimeInterval,
  Color,
  PolylineGeometry,
  Primitive,
  GeometryInstance,
  PolylineColorAppearance,
  PolylineOutlineMaterialProperty,
  Timeline,
  sprintf,
  Entity, WebMapTileServiceImageryProvider,
} from 'cesium';
import * as Cesium from 'cesium';
import {CesiumZh} from "@/assets/js/cesiumZn.js"
import {getHistory,getAllHisWorker} from "@/api/worker.js"
import CONSTANTS from "@/views/control/map/constants";
export default {
  name: 'History',
  data(){
    return {
      trackTime:[],//时间
      tracks:[],//轨迹线
      timeEnties:{},//查看的模型
      pickerOptions:{
         shortcuts: [{
            text: '最近6小时',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 6);
              picker.$emit('pick', [start, end]);
            }
          }]
      },
      SETime: [new Date(), new Date()],
      viewer:undefined,
      center:[],//中心点
      begintime:"1800-01-01 10:10:10",
      endtime:"2800-01-01 10:10:10",
      start:null,
      stop:null,
      username:"",//用户名
      password:"",//密码
      data:[],
      startTime:"",//时间条开始时间
      startTimeDate:"",//开始时间 Date格式
      stopTime:"",//时间条结束时间
      trackPrimitive:null,//轨迹线
      timeIndex:0,//定时事件
      currentTime:0,//当前时间
      workOptions:[],//人员
      czml:[],
      deveuis:""
    }
  },
  props: {
    specifictype:String,//类型
  },
  methods:{
    getWorks(){
       let username=this.username=this.D3Config.username
      let password=this.password=this.D3Config.password
      let _this=this
      getAllHisWorker( username,password).then((res)=>{
         _this.workOptions=res.data.data.rows;
      })
    },
    timeLineVisable(){

    },
    parseTime(time, cFormat) {
      if (arguments.length === 0 || !time) {
        return null
      }
      const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
      let date
      if (typeof time === 'object') {
        date = time
      } else {
        if ((typeof time === 'string')) {
          if ((/^[0-9]+$/.test(time))) {
            // support "1548221490638"
            time = parseInt(time)
          } else {
            // support safari
            // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
            time = time.replace(new RegExp(/-/gm), '/')
          }
        }

        if ((typeof time === 'number') && (time.toString().length === 10)) {
          time = time * 1000
        }
        date = new Date(time)
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
      }
      const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
        return value.toString().padStart(2, '0')
      })
      return time_str
    },
    //时间选择变化
    dateChange(){
      this.begintime=this.parseTime(this.SETime[0]);
      this.endtime=this.parseTime(this.SETime[1]);
      
      this.currentTime=0;
      this.tracks.splice(0);
      this.trackTime.splice(0);
      // if(this.timeIndex){
      //   clearInterval(this.timeIndex)
      // }
      
     
      // this.clearEnties()
      this.checkHistory()
    },
    //查看历史轨迹
    checkHistory(deveuis){
      let _this=this;
      if(deveuis){
        _this.deveuis=deveuis;
      }
      _this.clearEnties();
      getHistory(_this.username,_this.password,_this.begintime,_this.endtime,_this.deveuis).then((res)=>{
        let data=_this.data=res.data.data
        if(data&&data.length&&data.length>0){
          _this.startTimeDate=new Date(data[0].time);
          let startTime=_this.startTime=JulianDate.fromDate(_this.startTimeDate);
          let stopTime=_this.stopTime=JulianDate.fromDate(new Date(data[data.length-1].time));
          let interval=startTime.toString()+"/"+stopTime.toString()
          _this.viewer.clock.startTime=startTime.clone();
          _this.viewer.clock.stopTime=stopTime.clone();
          _this.viewer.timeline.zoomTo(_this.viewer.clock.startTime,_this.viewer.clock.stopTime);
          let trackFromData=_this.getTrackFromData(data);

          _this.center=[data[0].lon,data[0].lat]
          _this.viewer.camera.setView({
            destination:Cartesian3.fromDegrees(_this.center[0],_this.center[1],200)
          })
          let uri="/static/Soldier.glb"
          if(_this.specifictype=="4"){
            uri="/static/truck.glb"
          }
          let czml=[
            {
              id: "document",
              name: "CZML Path",
              version: "1.0",
              clock: {
                interval: interval,
                currentTime: startTime.toString(),
                multiplier: 1,
              },
            },
            {
              id: "path",
              name: "path with GPS flight data",
              description:
                "",
              availability: interval,
              path: {
                material: {
                  polylineOutline: {
                    color: {
                      rgba: [255, 0, 255, 255],
                    },
                    outlineWidth: 0,
                  },
                },
                width: 4,
                leadTime: 10,
                // trailTime: 1000,
                resolution: 5,
              },
              billboard: {
                image:require("@/assets/img/map/worker0.png"),
                scale: 1,
                eyeOffset: {
                  cartesian: [0.0, 0.0, -10.0],
                },
              },
              // model: {
              //     uri: uri,
              //     minimumPixelSize: 5,
              //     maximumScale: 20,
              //     scale: 1,
              // },
              position: {
                epoch: startTime.toString(),
                cartographicDegrees:trackFromData.cartographicDegrees,
              },
            },
          ]
          // debugger
          // _this.createTimeEnties(data,startTime)

          _this.viewer.dataSources
          .add(CzmlDataSource.load(czml))
          .then(function (ds) {
            _this.viewer.trackedEntity = ds.entities.getById("path");
          });
          _this.viewer.entities.add({
            name: 'Red line on terrain',
            polyline: {
              positions: trackFromData.positions,
              width: 4,
              material: Cesium.Color.GREEN,
              clampToGround: true
            }
          });
        }
        else{
          this.$message('无历史轨迹信息');
        }
      })
    },
    //组织轨迹线信息
    getTrackFromData(data){
      this.currentTime=0;
      let tracks=[];
      let positions=[];
      if(data&&data.length&&data.length>0){
        for(let i=0;i<data.length;i++){
          let track=data[i];
          let timeD=((new Date(data[i].time)).getTime()-this.startTimeDate.getTime())*0.001
          tracks.push(timeD,track.lon,track.lat,1)
          positions.push(Cesium.Cartesian3.fromDegrees(track.lon,track.lat,CONSTANTS.ALTITUDE));
        }
      }
      //positions.push(Cesium.Cartesian3.fromDegrees(120.05734074593425,31.670058323063564,CONSTANTS.ALTITUDE));
      return {cartographicDegrees:tracks,positions:positions};
    },
    //清空之前的
    clearEnties(){
      if(this.viewer){
        this.viewer.clock.tick()
        this.viewer.entities.removeAll();
      }
    },
    clear(){
      this.viewer.dataSources.removeAll(false)
    },
    //创建时间进度条
    createTimeEnties(data,begintime){
      let _this=this;
      this.viewer.entities.removeAll();
      this.viewer.entities.remove(_this.timeEnties);
      let property = this.computeFlight(data,begintime);
      let uri="static/Soldier.glb"
      if(_this.specifictype=="4"){
        uri="static/truck.glb"
      }
      
      _this.timeEnties={
          // 和时间轴关联
          availability : new TimeIntervalCollection([new TimeInterval({
              start : this.startTime,
              stop : this.stopTime,
              // length:100,
          })]),
          
          position: property,
          // 根据所提供的速度计算模型的朝向
          orientation: new VelocityOrientationProperty(property),
          // 模型数据
          model: {
              uri: uri,
              minimumPixelSize: 5,
              maximumScale: 20,
              scale: 1,
          }
      }
      // 添加模型
      // this.viewer.trackedEntity = _this.timeEnties;
       this.viewer.trackedEntity=this.viewer.entities.add(_this.timeEnties)
    },
    // 更新轨迹线
    updatePlaybackLine:function (time) {
      let index=this.trackTime.indexOf(time)
      let _this=this
      if(index>-1&&this.currentTime!=time&&index<this.trackTime.length-2){
        this.currentTime=time
        let positions=Cartesian3.fromDegreesArrayHeights(this.tracks.slice(0,3+3*(index+1)));
        // setTimeout(function(){
          
        // })
        
        let trackPrimitive= new Entity({
            name: 'track',
            polyline:{
              positions: positions,
              width: 3.0,
              material : new PolylineOutlineMaterialProperty({
                  color : Color.ORANGE,
                  outlineWidth : 2,
                  outlineColor : Color.BLACK
              })
            }
        });
        this.viewer.entities.add(trackPrimitive)
        _this.viewer.entities.remove(_this.trackPrimitive)
        _this.trackPrimitive=trackPrimitive

      }
    },
    tick:function() {
        // _this.viewer.clock.tick();
        
        let time=this.viewer.clock.currentTime.toString().slice(0,19);//后台打印实时时间
        this.updatePlaybackLine(time)
      },
    init(){
      let _this=this;
      var view =this.viewer= new Viewer('historyContainer',{
          baseLayerPicker:false,
          timeline:true,
          homeButton:false,
          fullscreenButton:false,
          infoBox:false,
          geocoder:false,
          sceneModePicker:false,
          navigationInstructionsInitiallyVisible:false,
          navigationHelpButton:false,
          shouldAnimate : true,
          animation:true,
          imageryProvider:new WebMapTileServiceImageryProvider({
            //影像底图
            url: "https://t4.tianditu.gov.cn/img_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=img&tileMatrixSet=w&TileMatrix={TileMatrix}&TileRow={TileRow}&TileCol={TileCol}&style=default&format=tiles&tk=c6b646f2d0b02ff507effd9221b21c66",
            layer: "tdtCiaLayer",
            style: "default",
            format: "image/jpeg",
            maximumLevel:18,
            tileMatrixSetID: "GoogleMapsCompatible",
            show: true
          })
      });
      view.imageryLayers.addImageryProvider(new WebMapTileServiceImageryProvider({
        //影像注记
        url: "https://t4.tianditu.gov.cn/cia_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=cia&tileMatrixSet=w&TileMatrix={TileMatrix}&TileRow={TileRow}&TileCol={TileCol}&style=default.jpg&tk=c6b646f2d0b02ff507effd9221b21c66",
        layer: "tdtCiaLayer",
        style: "default",
        format: "image/jpeg",
        maximumLevel:18,
        tileMatrixSetID: "GoogleMapsCompatible",
        show: true
      }));

      //加载3dtiles
      let manufacturer = localStorage.getItem('manufacturer');
      if(manufacturer) {
        let palaceTileset = new Cesium.Cesium3DTileset({
          url: '/static/3dtiles/'+manufacturer+'/tileset.json'
        })
        view.scene.primitives.add(palaceTileset);
      }

      //去除版权信息
      view._cesiumWidget._creditContainer.style.display = "none";
      view.scene.globe.enableLighting = true;
      view.scene.globe.enableLighting = true;
      let data=this.data;
      var date = new Date();//可返回格林威治时间和本地时间之间的时差
      var h = 0 - date.getTimezoneOffset();
      view.animation.viewModel.timeFormatter = function(date, viewModel) {
  　　　　//重新构造一个当前系统时间的儒略日
        var dateZone = JulianDate.addMinutes(date,h,new JulianDate());
        var gregorianDate = JulianDate.toGregorianDate(dateZone);
        var millisecond = Math.round(gregorianDate.millisecond );
　　　　　//倍速是否小于1，小于1则显示毫秒级
        if(Math.abs(viewModel._clockViewModel.multiplier) < 1){
            return sprintf("%02d:%02d:%02d.%03d",gregorianDate.hour,gregorianDate.minute,gregorianDate.second,gregorianDate.millisecond);
        }
        return sprintf("%02d:%02d:%02d",gregorianDate.hour,gregorianDate.minute,gregorianDate.second);
    };
    view.animation.viewModel.dateFormatter = function(date, viewModel) {
        var dateZone = JulianDate.addMinutes(date,h,new JulianDate());
        var gregorianDate = JulianDate.toGregorianDate(dateZone);
　　　　　//设置格式为xx/xx/xx，格式可自定义为任意你想要的
        return sprintf("%4d/%02d/%02d",gregorianDate.year,gregorianDate.month,gregorianDate.day);
      };
      let twoDigits=function(s){
        if(s<10) 
          return "0"+s;
        else
          return s;
      };
      Timeline.prototype.makeLabel = function(e) {
          var date = new Date();
          var h = 0 - date.getTimezoneOffset();
  　　　　　//由于Cesium都是以JulianDate作为默认日期，所以参数e肯定为JulianDate类型，所以我们可以像上面clock改造一样改造
          var dateZone = JulianDate.addMinutes(e,h,new JulianDate());
          var t = JulianDate.toGregorianDate(dateZone)
            , i = t.millisecond
            , r = " UTC";
          if (0 < i && this._timeBarSecondsSpan < 3600) {
              for (r = Math.floor(i).toString(); r.length < 3; )
                  r = "0" + r;
              r = "." + r
          }
  　　　　　//这里就是设置格式的地方
          return  t.year + "/" + t.month + "/" + t.day + " " + twoDigits(t.hour) + ":" + twoDigits(t.minute) + ":" + twoDigits(t.second)
      };
      // 起始时间
      let start = JulianDate.fromDate(new Date(this.begintime));
      // 结束时间
      let stop = JulianDate.fromDate(new Date(this.endtime));
      
      // 时间速率，数字越大时间过的越快
      view.clock.multiplier = 1;
      // 循环执行,即为2，到达终止时间，重新从起点时间开始
      view.clock.clockRange = ClockRange.LOOP_STOP;
      
      
      view.camera.setView({
          destination:Cartesian3.fromDegrees(_this.D3Config.Camera.center[0],_this.D3Config.Camera.center[1],200)
        })
    },
      /**
      * 计算飞行
      * @param source 数据坐标
      * @returns {SampledPositionProperty|*}
      */
      computeFlight(source,start) {
        
          // 取样位置 相当于一个集合
          let property = new SampledPositionProperty();
          for(let i=0; i<source.length; i++){
              let timeD=((new Date(source[i].time)).getTime()-this.startTimeDate.getTime())*0.001
              let time = JulianDate.addSeconds(start, timeD, new JulianDate);
              let position = Cartesian3.fromDegrees(source[i].lon, source[i].lat, 0);
              // 添加位置，和时间对应
              property.addSample(time, position);
          }
          
          return property;
      }
  },
  mounted(){
    
      let username=this.username=this.D3Config.username
      let password=this.password=this.D3Config.password
      this.getWorks()
      Ion.defaultAccessToken = this.D3Config.IonToken
      CesiumZh.load();
      // debugger
      this.init()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#wselect{
  position: absolute;
  z-index: 1001;
  top: 25px;
  left:16%;
  /* max-width: 150px;
  max-height: 400px; */
  overflow-y: auto;
}
.block{
  position: absolute;
  z-index: 1001;
  top: 25px;
  width: 50%;
  left:28%;
}
#historyContainer{
  height:85vh;
  width: 75vw;
  position:absolute;
  top: 20px;
  z-index: 1000;
  left:15%;
  border: 4px solid #194271;
  border-radius: 5px;
}
h3 {
  margin: 40px 0 0;
}
/* ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
} */
a {
  color: #42b983;
}
.cesium-animation-rectButton{
  display:none;
}
</style>



